/**
 * Empty is valid only in dev, where Vite proxies /api to the local Rails. A
 * production build with no VITE_API_HOST is rejected in vite.config.ts, because
 * at runtime the failure is silent and awful: requests go to the static meet
 * origin, which answers with HTML, and every join dies on an opaque parse error.
 */
export const API_HOST: string = (import.meta.env.VITE_API_HOST as string | undefined) ?? ''

export const EXCHANGE_PATH = '/api/v1/public/livekit/connection_details'
export const MODERATION_PATH = '/api/v1/public/livekit/moderation'
export const FALLBACK_PATH = '/api/v1/public/livekit/fallback'
